import { useIntl } from "react-intl";
import { type BasicUsageCardLoaderProps, UsageCard } from "./UsageCard.js";
import { calculateUsageCost, TieredPriceProductId } from "@project/common";
import { IconMap } from "@tabler/icons-react";
import { INTERNATIONALIZED_UNIT_LABELS } from "../../../constants/productLabels.js";
import { useMantineTheme } from "@mantine/core";
import { useCustomStylesUsageSum } from "./hooks/fetchSums.js";
import { useProductDescriptions, useProductNames } from "./hooks/productLabels.js";
import type { To } from "./UsageChartWrapper.js";

export function CustomStylesUsageCard({
  to,
  productId,
  isLoadingSubscriptions,
}: BasicUsageCardLoaderProps & To) {
  const intl = useIntl();
  const { colors: { success } } = useMantineTheme();
  const { usageSum, isLoadingStyles, isErrorStyles } = useCustomStylesUsageSum({ to });

  const getName = useProductNames();
  const getDescription = useProductDescriptions();

  const unitLabel = intl.formatMessage(INTERNATIONALIZED_UNIT_LABELS.map);

  return (
    <UsageCard
      unitLabel={unitLabel}
      usageSum={usageSum}
      productId={productId}
      icon={<IconMap />}
      iconColor={success[2]}
      isError={isErrorStyles}
      isLoading={isLoadingSubscriptions || isLoadingStyles}
      usageCost={calculateUsageCost(usageSum, productId)}
      defaultProductId={TieredPriceProductId.TieredCustomStyle}
      name={getName(TieredPriceProductId.TieredCustomStyle)}
      description={getDescription(TieredPriceProductId.TieredCustomStyle)}
    />
  );
};
